import { NgModule } from '@angular/core';

import { LIB_CommonModule } from "pbc.angular";

import { ProjektService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [
    ProjektService,
  ],
  exports: []
})
export class ProjektServiceModule { }
